import { render, staticRenderFns } from "./CRONSettings.vue?vue&type=template&id=23ff153a"
import script from "./CRONSettings.vue?vue&type=script&lang=js"
export * from "./CRONSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports